// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .ck.ck-image-upload__panel{\n  padding:var(--ck-spacing-standard)\n}\n\n.ck.ck-image-upload__ck-finder-button{\n  display:block;\n  width:100%\n}\n\n[dir] .ck.ck-image-upload__ck-finder-button{\n  margin:var(--ck-spacing-standard) auto;\n  border:1px solid #ccc;\n  border-radius:var(--ck-border-radius)\n}", ""]);
// Exports
module.exports = exports;
